//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import Utils from "../../Scalesoft.Shared.FrontEnd/Scripts/Utils";
export class AjaxWebHubClientBase {
    protected constructor() {
    }
    
    // tslint:disable-next-line:variable-name
    protected getBaseUrl(_defaultBaseUrl: string, _parameterBaseUrl?: string): string {
        const baseUrl = Utils.getBaseUrl();
        if (baseUrl.slice(-1) === "/") {
            return baseUrl.slice(0, -1);
        }
        return baseUrl;
    }

    protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
        const antiForgeryTokenValue = Utils.getAntiForgeryToken();
        if (antiForgeryTokenValue !== undefined && antiForgeryTokenValue !== null) {
            options.headers = {
                ...options.headers,
                RequestVerificationToken: antiForgeryTokenValue,
            };
            ((options.headers) as any)["X-Requested-With"] = "XMLHttpRequest";
        }

        return Promise.resolve(options);
    }
}

export class DashboardApiClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getOnlineUsersByRole(signal?: AbortSignal): Promise<OnlineUsersByRoleWidgetDataJsContract> {
        let url_ = this.baseUrl + "/DashboardApi/GetOnlineUsersByRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOnlineUsersByRole(_response);
        });
    }

    protected processGetOnlineUsersByRole(response: Response): Promise<OnlineUsersByRoleWidgetDataJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnlineUsersByRoleWidgetDataJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OnlineUsersByRoleWidgetDataJsContract>(null as any);
    }
}

export class DntCaptchaApiClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    createDntCaptchaParams(signal?: AbortSignal): Promise<DNTCaptchaApiResponse> {
        let url_ = this.baseUrl + "/DntCaptchaApi/CreateDntCaptchaParams";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDntCaptchaParams(_response);
        });
    }

    protected processCreateDntCaptchaParams(response: Response): Promise<DNTCaptchaApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DNTCaptchaApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DNTCaptchaApiResponse>(null as any);
    }
}

export class HomeApiClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    loadPortalConfiguration(signal?: AbortSignal): Promise<PortalConfigurationJsContract> {
        let url_ = this.baseUrl + "/HomeApi/LoadPortalConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoadPortalConfiguration(_response);
        });
    }

    protected processLoadPortalConfiguration(response: Response): Promise<PortalConfigurationJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortalConfigurationJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortalConfigurationJsContract>(null as any);
    }

    getKnownInsuranceCompanies(signal?: AbortSignal): Promise<InsuranceCompanyModel[]> {
        let url_ = this.baseUrl + "/HomeApi/GetKnownInsuranceCompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetKnownInsuranceCompanies(_response);
        });
    }

    protected processGetKnownInsuranceCompanies(response: Response): Promise<InsuranceCompanyModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceCompanyModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceCompanyModel[]>(null as any);
    }

    changeUserRole(role: string | null | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/HomeApi/ChangeUserRole?";
        if (role !== undefined && role !== null)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeUserRole(_response);
        });
    }

    protected processChangeUserRole(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    loadMenuItems(signal?: AbortSignal): Promise<MenuItemModelInverse[]> {
        let url_ = this.baseUrl + "/HomeApi/LoadMenuItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoadMenuItems(_response);
        });
    }

    protected processLoadMenuItems(response: Response): Promise<MenuItemModelInverse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MenuItemModelInverse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MenuItemModelInverse[]>(null as any);
    }

    setUserFacility(facilityId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/HomeApi/SetUserFacility?";
        if (facilityId === null)
            throw new globalThis.Error("The parameter 'facilityId' cannot be null.");
        else if (facilityId !== undefined)
            url_ += "facilityId=" + encodeURIComponent("" + facilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetUserFacility(_response);
        });
    }

    protected processSetUserFacility(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    checkModuleDataAccess(areaName: string | null | undefined, returnUrl: string | null | undefined, signal?: AbortSignal): Promise<ModuleDataAccessResultJsContract> {
        let url_ = this.baseUrl + "/HomeApi/CheckModuleDataAccess?";
        if (areaName !== undefined && areaName !== null)
            url_ += "areaName=" + encodeURIComponent("" + areaName) + "&";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckModuleDataAccess(_response);
        });
    }

    protected processCheckModuleDataAccess(response: Response): Promise<ModuleDataAccessResultJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ModuleDataAccessResultJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleDataAccessResultJsContract>(null as any);
    }
}

export class NotificationApiClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    markAsRead(id: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/NotificationApi/MarkAsRead?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkAsRead(_response);
        });
    }

    protected processMarkAsRead(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    markAllAsRead(idList: number[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/NotificationApi/MarkAllAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkAllAsRead(_response);
        });
    }

    protected processMarkAllAsRead(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    markNotificationDismissed(id: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/NotificationApi/MarkNotificationDismissed?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkNotificationDismissed(_response);
        });
    }

    protected processMarkNotificationDismissed(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    markAllNotificationsDismissed(idList: number[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/NotificationApi/MarkAllNotificationsDismissed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkAllNotificationsDismissed(_response);
        });
    }

    protected processMarkAllNotificationsDismissed(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    hasNewNotifications(disableLoginProlong: boolean | undefined, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/NotificationApi/HasNewNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Disable-Login-Prolong": disableLoginProlong !== undefined && disableLoginProlong !== null ? "" + disableLoginProlong : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasNewNotifications(_response);
        });
    }

    protected processHasNewNotifications(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getNotificationsForCurrentUser(signal?: AbortSignal): Promise<PortalNotificationContract[]> {
        let url_ = this.baseUrl + "/NotificationApi/GetNotificationsForCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNotificationsForCurrentUser(_response);
        });
    }

    protected processGetNotificationsForCurrentUser(response: Response): Promise<PortalNotificationContract[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortalNotificationContract[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortalNotificationContract[]>(null as any);
    }
}

export class UpdateApiClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    triggerUpdatePortal(version: string | null | undefined, accessCode: string | null | undefined, backupIis: boolean | undefined, updateDotnet: boolean | undefined, requiredDotnetVersion: string | null | undefined, signal?: AbortSignal): Promise<UpdateTriggerResult> {
        let url_ = this.baseUrl + "/UpdateApi/TriggerUpdate?";
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        if (accessCode !== undefined && accessCode !== null)
            url_ += "accessCode=" + encodeURIComponent("" + accessCode) + "&";
        if (backupIis === null)
            throw new globalThis.Error("The parameter 'backupIis' cannot be null.");
        else if (backupIis !== undefined)
            url_ += "backupIis=" + encodeURIComponent("" + backupIis) + "&";
        if (updateDotnet === null)
            throw new globalThis.Error("The parameter 'updateDotnet' cannot be null.");
        else if (updateDotnet !== undefined)
            url_ += "updateDotnet=" + encodeURIComponent("" + updateDotnet) + "&";
        if (requiredDotnetVersion !== undefined && requiredDotnetVersion !== null)
            url_ += "requiredDotnetVersion=" + encodeURIComponent("" + requiredDotnetVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTriggerUpdatePortal(_response);
        });
    }

    protected processTriggerUpdatePortal(response: Response): Promise<UpdateTriggerResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateTriggerResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateTriggerResult>(null as any);
    }

    isUpdaterRunning(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/UpdateApi/IsUpdaterRunning";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsUpdaterRunning(_response);
        });
    }

    protected processIsUpdaterRunning(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    triggerUpdateApi(version: string | null | undefined, accessCode: string | null | undefined, backupIis: boolean | undefined, updateDotnet: boolean | undefined, requiredDotnetVersion: string | null | undefined, signal?: AbortSignal): Promise<UpdateTriggerResult> {
        let url_ = this.baseUrl + "/UpdateApi/TriggerUpdateApi?";
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        if (accessCode !== undefined && accessCode !== null)
            url_ += "accessCode=" + encodeURIComponent("" + accessCode) + "&";
        if (backupIis === null)
            throw new globalThis.Error("The parameter 'backupIis' cannot be null.");
        else if (backupIis !== undefined)
            url_ += "backupIis=" + encodeURIComponent("" + backupIis) + "&";
        if (updateDotnet === null)
            throw new globalThis.Error("The parameter 'updateDotnet' cannot be null.");
        else if (updateDotnet !== undefined)
            url_ += "updateDotnet=" + encodeURIComponent("" + updateDotnet) + "&";
        if (requiredDotnetVersion !== undefined && requiredDotnetVersion !== null)
            url_ += "requiredDotnetVersion=" + encodeURIComponent("" + requiredDotnetVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTriggerUpdateApi(_response);
        });
    }

    protected processTriggerUpdateApi(response: Response): Promise<UpdateTriggerResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateTriggerResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateTriggerResult>(null as any);
    }

    triggerDotnetUpgrade(dotnetVersion: string | null | undefined, signal?: AbortSignal): Promise<UpdateTriggerResult> {
        let url_ = this.baseUrl + "/UpdateApi/TriggerDotnetUpgrade?";
        if (dotnetVersion !== undefined && dotnetVersion !== null)
            url_ += "dotnetVersion=" + encodeURIComponent("" + dotnetVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTriggerDotnetUpgrade(_response);
        });
    }

    protected processTriggerDotnetUpgrade(response: Response): Promise<UpdateTriggerResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateTriggerResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateTriggerResult>(null as any);
    }

    triggerUpdaterUpdate(updaterVersion: string | null | undefined, signal?: AbortSignal): Promise<UpdateTriggerResult> {
        let url_ = this.baseUrl + "/UpdateApi/TriggerUpdaterUpdate?";
        if (updaterVersion !== undefined && updaterVersion !== null)
            url_ += "updaterVersion=" + encodeURIComponent("" + updaterVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTriggerUpdaterUpdate(_response);
        });
    }

    protected processTriggerUpdaterUpdate(response: Response): Promise<UpdateTriggerResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateTriggerResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateTriggerResult>(null as any);
    }

    triggerPostgresqlUpdate(type: PostgresqlUpdateType | undefined, backupDb: boolean | undefined, doPurge: boolean | undefined, majorToUpdate: number | null | undefined, signal?: AbortSignal): Promise<UpdateTriggerResult> {
        let url_ = this.baseUrl + "/UpdateApi/TriggerPostgresqlUpdate?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (backupDb === null)
            throw new globalThis.Error("The parameter 'backupDb' cannot be null.");
        else if (backupDb !== undefined)
            url_ += "backupDb=" + encodeURIComponent("" + backupDb) + "&";
        if (doPurge === null)
            throw new globalThis.Error("The parameter 'doPurge' cannot be null.");
        else if (doPurge !== undefined)
            url_ += "doPurge=" + encodeURIComponent("" + doPurge) + "&";
        if (majorToUpdate !== undefined && majorToUpdate !== null)
            url_ += "majorToUpdate=" + encodeURIComponent("" + majorToUpdate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTriggerPostgresqlUpdate(_response);
        });
    }

    protected processTriggerPostgresqlUpdate(response: Response): Promise<UpdateTriggerResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateTriggerResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateTriggerResult>(null as any);
    }

    getUpdaterState(signal?: AbortSignal): Promise<UpdaterStateContract> {
        let url_ = this.baseUrl + "/UpdateApi/State";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUpdaterState(_response);
        });
    }

    protected processGetUpdaterState(response: Response): Promise<UpdaterStateContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdaterStateContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdaterStateContract>(null as any);
    }
}

export class UserAjaxClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    editSelfUserData(userData: UserWithContactsJsContract, signal?: AbortSignal): Promise<UserWithContactsJsContract> {
        let url_ = this.baseUrl + "/UserAjax/EditSelfUserData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditSelfUserData(_response);
        });
    }

    protected processEditSelfUserData(response: Response): Promise<UserWithContactsJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserWithContactsJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserWithContactsJsContract>(null as any);
    }
}

export class UsersApiClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getInviteInfo(userId: number | undefined, signal?: AbortSignal): Promise<UserInviteInfoJsContract> {
        let url_ = this.baseUrl + "/UsersApi/GetInviteInfo?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInviteInfo(_response);
        });
    }

    protected processGetInviteInfo(response: Response): Promise<UserInviteInfoJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserInviteInfoJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInviteInfoJsContract>(null as any);
    }

    getConvertedPatientEmails(userId: number | undefined, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/UsersApi/GetConvertedPatientEmails?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConvertedPatientEmails(_response);
        });
    }

    protected processGetConvertedPatientEmails(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    sendInviteByCode(userId: number | undefined, contract: SendUserInviteJsContract, signal?: AbortSignal): Promise<InviteSentResultJsContract> {
        let url_ = this.baseUrl + "/UsersApi/SendInviteByCode?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contract);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendInviteByCode(_response);
        });
    }

    protected processSendInviteByCode(response: Response): Promise<InviteSentResultJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InviteSentResultJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InviteSentResultJsContract>(null as any);
    }

    finishAccountRegistration(userId: number | undefined, signal?: AbortSignal): Promise<AccountRegistrationFinishJsContract> {
        let url_ = this.baseUrl + "/UsersApi/FinishAccountRegistration?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFinishAccountRegistration(_response);
        });
    }

    protected processFinishAccountRegistration(response: Response): Promise<AccountRegistrationFinishJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountRegistrationFinishJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountRegistrationFinishJsContract>(null as any);
    }

    sendFinishedAccountDataMessage(userId: number | undefined, contract: SendCreatedUserDataMessageJsContract, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/UsersApi/SendFinishedAccountDataMessage?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contract);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendFinishedAccountDataMessage(_response);
        });
    }

    protected processSendFinishedAccountDataMessage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    isMpiEnabled(signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/UsersApi/IsMpiEnabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsMpiEnabled(_response);
        });
    }

    protected processIsMpiEnabled(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    linkPatientWithMpi(userId: number | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/UsersApi/LinkPatientWithMpi?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLinkPatientWithMpi(_response);
        });
    }

    protected processLinkPatientWithMpi(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TemporaryContactSharedAjaxClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    createForValidation(waitForSendError: boolean | undefined, captchaTokenSerialized: string, contactBase: ContactBaseJsContract, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/TemporaryContactSharedAjax/CreateForValidation?";
        if (waitForSendError === null)
            throw new globalThis.Error("The parameter 'waitForSendError' cannot be null.");
        else if (waitForSendError !== undefined)
            url_ += "waitForSendError=" + encodeURIComponent("" + waitForSendError) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contactBase);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Captcha-Params": captchaTokenSerialized !== undefined && captchaTokenSerialized !== null ? "" + captchaTokenSerialized : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateForValidation(_response);
        });
    }

    protected processCreateForValidation(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    update(captchaTokenSerialized: string, temporaryContactJsContract: TemporaryContactJsContract, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/TemporaryContactSharedAjax/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(temporaryContactJsContract);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Captcha-Params": captchaTokenSerialized !== undefined && captchaTokenSerialized !== null ? "" + captchaTokenSerialized : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    verify(temporaryContactJsContract: TemporaryContactJsContract, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/TemporaryContactSharedAjax/Verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(temporaryContactJsContract);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    resendVerificationCode(captchaTokenSerialized: string, temporaryContactJsContract: TemporaryContactJsContract, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/TemporaryContactSharedAjax/ResendVerificationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(temporaryContactJsContract);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Captcha-Params": captchaTokenSerialized !== undefined && captchaTokenSerialized !== null ? "" + captchaTokenSerialized : "",
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendVerificationCode(_response);
        });
    }

    protected processResendVerificationCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(temporaryContactJsContract: TemporaryContactJsContract, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/TemporaryContactSharedAjax/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(temporaryContactJsContract);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class UserContactSharedAjaxClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    createForValidation(waitForSendError: boolean | undefined, captchaTokenSerialized: string, contactBase: ContactBaseJsContract, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/UserContactSharedAjax/CreateForValidation?";
        if (waitForSendError === null)
            throw new globalThis.Error("The parameter 'waitForSendError' cannot be null.");
        else if (waitForSendError !== undefined)
            url_ += "waitForSendError=" + encodeURIComponent("" + waitForSendError) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contactBase);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Captcha-Params": captchaTokenSerialized !== undefined && captchaTokenSerialized !== null ? "" + captchaTokenSerialized : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateForValidation(_response);
        });
    }

    protected processCreateForValidation(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    update(captchaTokenSerialized: string, persistentContactJsContract: PersistentContactJsContract, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/UserContactSharedAjax/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(persistentContactJsContract);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Captcha-Params": captchaTokenSerialized !== undefined && captchaTokenSerialized !== null ? "" + captchaTokenSerialized : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    verify(persistentContactJsContract: PersistentContactJsContract, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/UserContactSharedAjax/Verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(persistentContactJsContract);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    resendVerificationCode(captchaTokenSerialized: string, persistentContactJsContract: PersistentContactJsContract, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/UserContactSharedAjax/ResendVerificationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(persistentContactJsContract);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Captcha-Params": captchaTokenSerialized !== undefined && captchaTokenSerialized !== null ? "" + captchaTokenSerialized : "",
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendVerificationCode(_response);
        });
    }

    protected processResendVerificationCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(persistentContactJsContract: PersistentContactJsContract, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/UserContactSharedAjax/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(persistentContactJsContract);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class RegistrationAjaxClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getExternalIdentityProviderRegistration(signal?: AbortSignal): Promise<PagedListJsContractOfExternalLoginProviderJsContract> {
        let url_ = this.baseUrl + "/RegistrationAjax/GetExternalIdentityProviderRegistration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExternalIdentityProviderRegistration(_response);
        });
    }

    protected processGetExternalIdentityProviderRegistration(response: Response): Promise<PagedListJsContractOfExternalLoginProviderJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListJsContractOfExternalLoginProviderJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedListJsContractOfExternalLoginProviderJsContract>(null as any);
    }

    getExternalIdentityProvidersForVerification(signal?: AbortSignal): Promise<ExternalLoginProviderJsContract[]> {
        let url_ = this.baseUrl + "/RegistrationAjax/GetExternalIdentityProvidersForVerification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExternalIdentityProvidersForVerification(_response);
        });
    }

    protected processGetExternalIdentityProvidersForVerification(response: Response): Promise<ExternalLoginProviderJsContract[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExternalLoginProviderJsContract[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalLoginProviderJsContract[]>(null as any);
    }

    sendGalenUserImportRequest(captchaTokenSerialized: string, userImportRequest: GalenUserImportRequestJsContract, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/RegistrationAjax/SendGalenUserImportRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userImportRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Captcha-Params": captchaTokenSerialized !== undefined && captchaTokenSerialized !== null ? "" + captchaTokenSerialized : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendGalenUserImportRequest(_response);
        });
    }

    protected processSendGalenUserImportRequest(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    resendGalenPinCode(captchaTokenSerialized: string, userImportRequest: GalenUserImportRequestJsContract, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/RegistrationAjax/ResendGalenPinCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userImportRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Captcha-Params": captchaTokenSerialized !== undefined && captchaTokenSerialized !== null ? "" + captchaTokenSerialized : "",
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendGalenPinCode(_response);
        });
    }

    protected processResendGalenPinCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendGalenUserImportWithPinRequest(userImportRequest: GalenUserImportWithPinRequestJsContract, signal?: AbortSignal): Promise<PreparedUserRegistrationJsContract> {
        let url_ = this.baseUrl + "/RegistrationAjax/SendGalenUserImportWithPinRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userImportRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendGalenUserImportWithPinRequest(_response);
        });
    }

    protected processSendGalenUserImportWithPinRequest(response: Response): Promise<PreparedUserRegistrationJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreparedUserRegistrationJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreparedUserRegistrationJsContract>(null as any);
    }

    finalizeImportUserFromGalen(captchaTokenSerialized: string, userRegistrationJsContract: GalenUserRegistrationJsContract, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/RegistrationAjax/FinalizeImportUserFromGalen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userRegistrationJsContract);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Captcha-Params": captchaTokenSerialized !== undefined && captchaTokenSerialized !== null ? "" + captchaTokenSerialized : "",
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFinalizeImportUserFromGalen(_response);
        });
    }

    protected processFinalizeImportUserFromGalen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getExternalUserData(signal?: AbortSignal): Promise<UserRegistrationValidationResultJsContract> {
        let url_ = this.baseUrl + "/RegistrationAjax/GetExternalUserData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExternalUserData(_response);
        });
    }

    protected processGetExternalUserData(response: Response): Promise<UserRegistrationValidationResultJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserRegistrationValidationResultJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserRegistrationValidationResultJsContract>(null as any);
    }

    registerUser(captchaTokenSerialized: string, userRegistrationJsContract: UserRegistrationJsContract, signal?: AbortSignal): Promise<VerificationInstructionsJsContract> {
        let url_ = this.baseUrl + "/RegistrationAjax/RegisterUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userRegistrationJsContract);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Captcha-Params": captchaTokenSerialized !== undefined && captchaTokenSerialized !== null ? "" + captchaTokenSerialized : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterUser(_response);
        });
    }

    protected processRegisterUser(response: Response): Promise<VerificationInstructionsJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VerificationInstructionsJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationInstructionsJsContract>(null as any);
    }

    getRegistrationValidationConfiguration(signal?: AbortSignal): Promise<RegistrationValidationJsContract> {
        let url_ = this.baseUrl + "/RegistrationAjax/GetRegistrationValidationConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationValidationConfiguration(_response);
        });
    }

    protected processGetRegistrationValidationConfiguration(response: Response): Promise<RegistrationValidationJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegistrationValidationJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationValidationJsContract>(null as any);
    }

    getVerificationInstructionsPage(signal?: AbortSignal): Promise<HtmlString> {
        let url_ = this.baseUrl + "/RegistrationAjax/GetVerificationInstructionsPage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVerificationInstructionsPage(_response);
        });
    }

    protected processGetVerificationInstructionsPage(response: Response): Promise<HtmlString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HtmlString;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HtmlString>(null as any);
    }
}

export class LocalizationClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDefaultCulture(signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/Localization/GetDefaultCulture";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDefaultCulture(_response);
        });
    }

    protected processGetDefaultCulture(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getDictionariesForFrontendLocalization(requiredScopes: string[], signal?: AbortSignal): Promise<LocalizationDictionaryJsContract[]> {
        let url_ = this.baseUrl + "/Localization/GetDictionariesForFrontendLocalization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requiredScopes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDictionariesForFrontendLocalization(_response);
        });
    }

    protected processGetDictionariesForFrontendLocalization(response: Response): Promise<LocalizationDictionaryJsContract[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocalizationDictionaryJsContract[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocalizationDictionaryJsContract[]>(null as any);
    }

    getSupportedCultures(signal?: AbortSignal): Promise<CultureInfoJsContract[]> {
        let url_ = this.baseUrl + "/Localization/GetSupportedCultures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportedCultures(_response);
        });
    }

    protected processGetSupportedCultures(response: Response): Promise<CultureInfoJsContract[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CultureInfoJsContract[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CultureInfoJsContract[]>(null as any);
    }

    setLanguageAjax(culture: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Localization/SetLanguageAjax?";
        if (culture !== undefined && culture !== null)
            url_ += "culture=" + encodeURIComponent("" + culture) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetLanguageAjax(_response);
        });
    }

    protected processSetLanguageAjax(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RepresentedPersonClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getUserRepresentedPersonList(idValue: number | undefined, signal?: AbortSignal): Promise<RepresentedPersonDetailJsContract[]> {
        let url_ = this.baseUrl + "/RepresentedPerson/GetUserRepresentedPersonList?";
        if (idValue === null)
            throw new globalThis.Error("The parameter 'idValue' cannot be null.");
        else if (idValue !== undefined)
            url_ += "idValue=" + encodeURIComponent("" + idValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserRepresentedPersonList(_response);
        });
    }

    protected processGetUserRepresentedPersonList(response: Response): Promise<RepresentedPersonDetailJsContract[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RepresentedPersonDetailJsContract[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RepresentedPersonDetailJsContract[]>(null as any);
    }

    getSuggestions(start: number | undefined, count: number | undefined, filter: RepresentedPersonFilterJsContract, signal?: AbortSignal): Promise<PagedListJsContractOfRepresentedPersonDetailJsContract> {
        let url_ = this.baseUrl + "/RepresentedPerson/GetSuggestions?";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSuggestions(_response);
        });
    }

    protected processGetSuggestions(response: Response): Promise<PagedListJsContractOfRepresentedPersonDetailJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListJsContractOfRepresentedPersonDetailJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedListJsContractOfRepresentedPersonDetailJsContract>(null as any);
    }

    createRepresentedPerson(personModel: CreateRepresentedPersonJsContract, signal?: AbortSignal): Promise<RepresentedPersonDetailJsContract> {
        let url_ = this.baseUrl + "/RepresentedPerson/CreateRepresentedPerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(personModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRepresentedPerson(_response);
        });
    }

    protected processCreateRepresentedPerson(response: Response): Promise<RepresentedPersonDetailJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RepresentedPersonDetailJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RepresentedPersonDetailJsContract>(null as any);
    }

    updateRepresentedPerson(personModel: RepresentedPersonDetailJsContract, signal?: AbortSignal): Promise<RepresentedPersonDetailJsContract> {
        let url_ = this.baseUrl + "/RepresentedPerson/UpdateRepresentedPerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(personModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateRepresentedPerson(_response);
        });
    }

    protected processUpdateRepresentedPerson(response: Response): Promise<RepresentedPersonDetailJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RepresentedPersonDetailJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RepresentedPersonDetailJsContract>(null as any);
    }

    assignRepresentedPerson(parentId: number | undefined, representedPerson: RepresentedPersonDetailJsContract, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/RepresentedPerson/AssignRepresentedPerson?";
        if (parentId === null)
            throw new globalThis.Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(representedPerson);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignRepresentedPerson(_response);
        });
    }

    protected processAssignRepresentedPerson(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getVerificationActions(signal?: AbortSignal): Promise<VerificationActionViewModel[]> {
        let url_ = this.baseUrl + "/RepresentedPerson/GetVerificationActions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVerificationActions(_response);
        });
    }

    protected processGetVerificationActions(response: Response): Promise<VerificationActionViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VerificationActionViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationActionViewModel[]>(null as any);
    }

    getInsuranceCompaniesList(signal?: AbortSignal): Promise<InsuranceCompanyModel[]> {
        let url_ = this.baseUrl + "/RepresentedPerson/GetInsuranceCompaniesList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceCompaniesList(_response);
        });
    }

    protected processGetInsuranceCompaniesList(response: Response): Promise<InsuranceCompanyModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceCompanyModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceCompanyModel[]>(null as any);
    }

    deleteRepresentedPerson(parentId: number | undefined, userId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/RepresentedPerson/DeleteRepresentedPerson?";
        if (parentId === null)
            throw new globalThis.Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRepresentedPerson(_response);
        });
    }

    protected processDeleteRepresentedPerson(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TermsOfUseClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getUserAgreementInfoList(start: number | null | undefined, count: number | null | undefined, licenseTermsId: number | null | undefined, filter: UserAgreementFilterJsContract | undefined, signal?: AbortSignal): Promise<PagedListJsContractOfUserAgreementJsContract> {
        let url_ = this.baseUrl + "/TermsOfUse/agreement-list?";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (licenseTermsId !== undefined && licenseTermsId !== null)
            url_ += "licenseTermsId=" + encodeURIComponent("" + licenseTermsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserAgreementInfoList(_response);
        });
    }

    protected processGetUserAgreementInfoList(response: Response): Promise<PagedListJsContractOfUserAgreementJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListJsContractOfUserAgreementJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedListJsContractOfUserAgreementJsContract>(null as any);
    }

    create(viewModel: EditableLicenseTermsInfoViewModel, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/TermsOfUse/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    deleteDELETE(id: number, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/TermsOfUse/{id}/delete";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDELETE(_response);
        });
    }

    protected processDeleteDELETE(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deletePOST(id: number, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/TermsOfUse/{id}/delete";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePOST(_response);
        });
    }

    protected processDeletePOST(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteVersionDELETE(id: number, versionId: number, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/TermsOfUse/{id}/version/{versionId}/delete";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteVersionDELETE(_response);
        });
    }

    protected processDeleteVersionDELETE(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteVersionPOST(id: number, versionId: number, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/TermsOfUse/{id}/version/{versionId}/delete";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteVersionPOST(_response);
        });
    }

    protected processDeleteVersionPOST(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    validity(idQuery: number | null | undefined, versionIdQuery: number | null | undefined, activateOnVersionDetail: boolean | undefined, idPath: number, versionIdPath: number, viewModel: LicenseTermsVersionInfoViewModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/TermsOfUse/{id}/version/{versionId}/validity?";
        if (idPath === undefined || idPath === null)
            throw new globalThis.Error("The parameter 'idPath' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idPath));
        if (versionIdPath === undefined || versionIdPath === null)
            throw new globalThis.Error("The parameter 'versionIdPath' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionIdPath));
        if (idQuery !== undefined && idQuery !== null)
            url_ += "id=" + encodeURIComponent("" + idQuery) + "&";
        if (versionIdQuery !== undefined && versionIdQuery !== null)
            url_ += "versionId=" + encodeURIComponent("" + versionIdQuery) + "&";
        if (activateOnVersionDetail === null)
            throw new globalThis.Error("The parameter 'activateOnVersionDetail' cannot be null.");
        else if (activateOnVersionDetail !== undefined)
            url_ += "activateOnVersionDetail=" + encodeURIComponent("" + activateOnVersionDetail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidity(_response);
        });
    }

    protected processValidity(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UserClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    createPreregisteredUser(personModel: PreregisteredUserJsContract, signal?: AbortSignal): Promise<CreatePreregisteredPersonResponseJsContract> {
        let url_ = this.baseUrl + "/User/CreatePreregisteredUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(personModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePreregisteredUser(_response);
        });
    }

    protected processCreatePreregisteredUser(response: Response): Promise<CreatePreregisteredPersonResponseJsContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePreregisteredPersonResponseJsContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatePreregisteredPersonResponseJsContract>(null as any);
    }
}

export class UserManagementApiClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    cancelLoginLockout(userId: number, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/UserManagementApi/{userId}/lockout";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelLoginLockout(_response);
        });
    }

    protected processCancelLoginLockout(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getLoginLockoutStatus(userId: number, signal?: AbortSignal): Promise<LoginLockoutStateContract> {
        let url_ = this.baseUrl + "/UserManagementApi/{userId}/lockout";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLoginLockoutStatus(_response);
        });
    }

    protected processGetLoginLockoutStatus(response: Response): Promise<LoginLockoutStateContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginLockoutStateContract;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginLockoutStateContract>(null as any);
    }
}

export class AccountClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Action that is called for refreshing session
     * @return Ok if user is authenticated, otherwise returns BadRequest
     */
    refreshLogin(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Account/RefreshLogin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRefreshLogin(_response);
        });
    }

    protected processRefreshLogin(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    isUserSignedIn(redirectUrl: string | null | undefined, signal?: AbortSignal): Promise<UserSignedInModel> {
        let url_ = this.baseUrl + "/Account/IsUserSignedIn?";
        if (redirectUrl !== undefined && redirectUrl !== null)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsUserSignedIn(_response);
        });
    }

    protected processIsUserSignedIn(response: Response): Promise<UserSignedInModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserSignedInModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSignedInModel>(null as any);
    }
}

export class FrontendAppsettingsClient extends AjaxWebHubClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getSettings(signal?: AbortSignal): Promise<FrontendAppsettingsModel> {
        let url_ = this.baseUrl + "/FrontendAppsettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSettings(_response);
        });
    }

    protected processGetSettings(response: Response): Promise<FrontendAppsettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FrontendAppsettingsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrontendAppsettingsModel>(null as any);
    }
}

export interface OnlineUsersByRoleWidgetDataJsContract {
    totalOnlineUsers?: number;
    roleCounts?: OnlineUsersByRoleCountItemJsContract[] | undefined;
}

export interface OnlineUsersByRoleCountItemJsContract {
    roleName?: string | undefined;
    count?: number;
}

/** ApiProvider Response */
export interface DNTCaptchaApiResponse {
    /** The captach's image url
             */
    dntCaptchaImgUrl?: string;
    /** Captcha Id
             */
    dntCaptchaId?: string;
    /** Captcha's TextValue
             */
    dntCaptchaTextValue?: string;
    /** Captcha's TokenValue
             */
    dntCaptchaTokenValue?: string;
}

export interface PortalConfigurationJsContract {
    currentUser?: LoggedUserJsContract | undefined;
    enableDynamicOverflowMenuDetection: boolean;
    menuItems: MenuItemModelInverse[];
    loginUrl: string;
    externalSignInUrl: string;
    environmentName: string;
    domainName: string;
    registrationUrl: string;
    cookiesPrivacyPolicyUrl: string;
    cookiesConfigUrl: string;
    environmentAlertText?: string | undefined;
    logoutRedirectUrl: string;
    footerText: FooterTextEnum;
    pageTitle: string;
    portalName: string;
    enabledFeatures: FeatureContract[];
    captchaConfig: CaptchaConfigJsContract;
    portalTermsOfUseUrl: string;
    registration: WebHubRegistrationConfigurationJsContract;
}

export interface LoggedUserJsContract {
    id: number;
    fullName: string;
    roles: { [key: string]: string; };
    currentRole: string;
    permissions: string[];
    profileUrl: string;
    adminPageLink: string;
    userFacilities?: FacilityViewModel[] | undefined;
    loginExpirationConfig: LoginExpirationConfigurationJsContract;
    hasInsufficientlyVerifiedData: boolean;
}

export interface FacilityViewModel {
    id?: number;
    name?: string | undefined;
    ico?: string | undefined;
    selected?: boolean;
}

export interface LoginExpirationConfigurationJsContract {
    timeInSeconds: number;
    warningBeforeExpirationInSeconds: number;
    afterLoginExpirationUrl: string;
    loginRefreshUrl: string;
    signoutUrl: string;
}

export interface MenuItemModelInverse {
    text?: string | undefined;
    icon?: string | undefined;
    position?: number;
    id?: number;
    parentId?: number | undefined;
    url?: string | undefined;
    queryString?: string | undefined;
    type?: MenuItemType;
    children?: MenuItemModelInverse[] | undefined;
    webHubModulePage?: WebHubModulePageModelInverse | undefined;
}

export enum MenuItemType {
    LocalPage = 0,
    ExternalLink = 1,
    Category = 2,
}

export interface WebHubModulePageModelInverse {
    id?: number;
    module?: ModuleModelInverse | undefined;
    relativePath?: string | undefined;
}

export interface ModuleModelInverse {
    id?: number | undefined;
    moduleId?: string;
    modulePath?: string | undefined;
    displayName?: string | undefined;
}

export enum FooterTextEnum {
    Stapro = 0,
    Scalesoft = 1,
    Hidden = 2,
    NoText = 3,
}

export enum FeatureContract {
    Users = "Users",
    Telemonitoring = "Telemonitoring",
    StructuredRequests = "StructuredRequests",
    Reservations = "Reservations",
    ClinicalDocuments = "ClinicalDocuments",
    TitlePages = "TitlePages",
    News = "News",
    NationalContactPointV3 = "NationalContactPointV3",
    InstanceManagement = "InstanceManagement",
    CertificatesManagement = "CertificatesManagement",
}

export interface CaptchaConfigJsContract {
    type: CaptchaType;
    dntCaptchaConfig: DntCaptchaConfigJsContract;
    reCaptchaV2Config: ReCaptchaV2ConfigJsContract;
    reCaptchaV3Config: ReCaptchaV3ConfigJsContract;
}

export enum CaptchaType {
    RecaptchaV3 = 1,
    DNTCaptcha = 2,
    RecaptchaV2 = 3,
}

export interface DntCaptchaConfigJsContract {
    captchaHeaderHiddenInputName: string;
    captchaHeaderHiddenTokenName: string;
    captchaHeaderInputName: string;
}

export interface ReCaptchaV2ConfigJsContract {
    publicKey: string;
    captchaHeaderRecaptchaV2: string;
}

export interface ReCaptchaV3ConfigJsContract {
    publicKey: string;
    captchaHeaderRecaptchaV3: string;
}

export interface WebHubRegistrationConfigurationJsContract {
    isDisabled?: boolean;
    isHidden?: boolean;
    isLocalLoginHidden?: boolean;
    enablePreregisteredUserForm?: boolean;
    isGalenMigrationEnabled?: boolean;
    markUserDataForVerification?: boolean;
    markContactsForVerification?: boolean;
    forceContactRulesDuringVerification?: boolean;
    sendVerificationCodeSms?: boolean;
    allowPreRegisteredUserVerification?: boolean;
}

export interface InsuranceCompanyModel {
    code?: string | undefined;
    name?: string | undefined;
}

export interface ModuleDataAccessResultJsContract {
    moduleDataAccessGranted: boolean;
    redirectUrl?: string | undefined;
}

export interface PortalNotificationContract {
    id?: number;
    createTime?: string;
    heading?: string | undefined;
    text?: string | undefined;
    readTime?: string | undefined;
    actionSubtypes?: ActionSubtypeContract[] | undefined;
    displayPriority?: DisplayPriorityEnumContract | undefined;
}

export interface ActionSubtypeContract {
    id?: number;
    name?: string | undefined;
}

export enum DisplayPriorityEnumContract {
    Normal = 0,
    High = 1,
}

export interface UpdateTriggerResult {
    success?: boolean;
    message?: string | undefined;
    updaterLoginUrl?: string | undefined;
    updaterUiStatusEndpoint?: string | undefined;
    updaterRunningStatusEndpoint?: string | undefined;
}

export enum PostgresqlUpdateType {
    Minor = "Minor",
    Major = "Major",
    TimescaleDbOnly = "TimescaleDbOnly",
    MinorOnly = "MinorOnly",
}

export interface UpdaterStateContract {
    currentUpdateStatus: string;
    isUpdateRunning?: boolean;
    currentUpdaterVersion: string;
    dotnetRuntimeVersion?: string | undefined;
}

export interface BaseUserDataJsContract {
    firstNamesList?: UserDataBaseJsContract[] | undefined;
    lastNamesList?: UserDataBaseJsContract[] | undefined;
    insuranceCompanyCode?: UserDataBaseJsContract | undefined;
    insuranceNumber?: UserDataBaseJsContract | undefined;
    birthTime?: UserDataBaseJsContract | undefined;
    personalIdNumber?: UserDataBaseJsContract | undefined;
}

export interface UserDataJsContract extends BaseUserDataJsContract {
    userType?: UserTypeEnumContract;
    title?: UserDataBaseJsContract | undefined;
    preNameDegree?: UserDataBaseJsContract | undefined;
    postNameDegree?: UserDataBaseJsContract | undefined;
    ehicCode?: UserDataBaseJsContract | undefined;
    identityCardCode?: UserDataBaseJsContract | undefined;
    postalAddresses?: PostalAddressJsContract[] | undefined;
}

export interface UserWithContactsJsContract extends UserDataJsContract {
    contactVerificationType?: ContactVerificationType;
    userContacts?: UserContactsJsContract | undefined;
}

export enum ContactVerificationType {
    ByUser = 0,
    ByRegistrator = 1,
    ByAdministrator = 2,
}

export interface UserContactsJsContract {
    emails?: PersistentContactJsContract[] | undefined;
    phoneNumbers?: PersistentContactJsContract[] | undefined;
}

export interface ContactBaseJsContract {
    contactType?: ContactTypeJsEnum;
    value?: string | undefined;
    confirmCode?: string | undefined;
    confirmed?: boolean;
    levelOfAssurance?: LevelOfAssuranceEnum;
}

export interface PersistentContactJsContract extends ContactBaseJsContract {
    id: number;
}

export enum ContactTypeJsEnum {
    Email = "Email",
    Phone = "Phone",
    LandlinePhone = "LandlinePhone",
    MobilePhone = "MobilePhone",
    Fax = "Fax",
    Website = "Website",
}

export enum LevelOfAssuranceEnum {
    Low = "Low",
    Substantial = "Substantial",
    High = "High",
}

export enum UserTypeEnumContract {
    Normal = "Normal",
    RepresentedPerson = "RepresentedPerson",
    PreRegistered = "PreRegistered",
    Deleted = "Deleted",
    NonAuthenticatedUser = "NonAuthenticatedUser",
}

export interface UserDataBaseJsContract {
    value?: string | undefined;
    levelOfAssurance?: LevelOfAssuranceEnum | undefined;
}

export interface PostalAddressJsContract {
    name?: UserDataBaseJsContract | undefined;
    type?: UserDataBaseJsContract | undefined;
    street: UserDataBaseJsContract;
    postalCode: UserDataBaseJsContract;
    city: UserDataBaseJsContract;
    country?: UserDataBaseJsContract | undefined;
    levelOfAssurance?: LevelOfAssuranceEnum | undefined;
}

export interface UserInviteInfoJsContract {
    lastNotificationSendTime?: string | undefined;
    hasInviteCodeGenerated?: boolean;
    hasInsuranceNumberFilled?: boolean;
    emailAddresses?: string[] | undefined;
}

export interface InviteSentResultJsContract {
    lastNotificationSendTime: string;
}

export interface SendUserInviteJsContract {
    emails: string[];
    insuranceNumber?: UserInviteInsuranceNumberJsContract | undefined;
}

export interface UserInviteInsuranceNumberJsContract {
    value?: string | undefined;
    markedForVerification?: boolean;
}

export interface AccountRegistrationFinishJsContract {
    password: string;
    username: string;
    resultUserType: UserTypeEnumJsContract;
}

export enum UserTypeEnumJsContract {
    Normal = 0,
    RepresentedPerson = 1,
    PreRegistered = 2,
    Deleted = 3,
    NonAuthenticatedUser = 4,
}

export interface SendCreatedUserDataMessageJsContract {
    username: string;
    password: string;
    emails: string[];
}

export interface TemporaryContactJsContract extends ContactBaseJsContract {
    temporaryId: number;
}

export interface PagedListJsContractOfExternalLoginProviderJsContract {
    totalCount?: number;
    items?: ExternalLoginProviderJsContract[] | undefined;
}

export interface ExternalLoginProviderJsContract {
    id: number;
    name: string;
    description?: string | undefined;
    isDisabled?: boolean;
    authenticationScheme: string;
    logoResourceId?: number;
    logoResourcePath?: string | undefined;
    verificationUrl?: string | undefined;
}

export interface GalenUserImportRequestJsContract {
    registrationCode: string;
    identityCardCode: UserDataBaseJsContract;
}

export interface PreparedUserRegistrationJsContract extends UserDataJsContract {
    sessionToken?: string | undefined;
    userContacts?: UserContactsDraftJsContract | undefined;
}

export interface UserContactsDraftJsContract {
    emails?: ContactDraftJsContract[] | undefined;
    phoneNumbers?: ContactDraftJsContract[] | undefined;
}

export interface ContactDraftJsContract extends ContactBaseJsContract {
}

export interface GalenUserImportWithPinRequestJsContract extends GalenUserImportRequestJsContract {
    pinCode: string;
}

export interface UserWithTemporaryContactsJsContract extends UserDataJsContract {
    contactVerificationType?: ContactVerificationType;
    userContacts?: TemporaryUserContactsJsContract | undefined;
}

export interface UserRegistrationJsContract extends UserWithTemporaryContactsJsContract {
    userPassword?: UserPasswordJsContract | undefined;
    isTermsAgreement?: boolean;
}

export interface GalenUserRegistrationJsContract extends UserRegistrationJsContract {
    sessionToken?: string | undefined;
}

export interface UserPasswordJsContract {
    password?: string | undefined;
    confirmPassword?: string | undefined;
}

export interface TemporaryUserContactsJsContract {
    emails?: TemporaryContactJsContract[] | undefined;
    phoneNumbers?: TemporaryContactJsContract[] | undefined;
}

export interface UserRegistrationValidationResultJsContract {
    data: UserWithContactsJsContract;
    missingFields: string[];
    contactValidationResult: ContactValidationJsContract;
}

export interface ContactValidationJsContract {
    isPhoneListValid: boolean;
    isEmailListValid: boolean;
}

export interface VerificationInstructionsJsContract {
    verificationCode: string;
    username: string;
}

export interface RegistrationValidationJsContract {
    validTo?: string;
    contactGroups?: string[] | undefined;
    addressTypes?: string[] | undefined;
    contactsConfiguration?: ContactConfigurationJsContract[] | undefined;
    userData?: UserDataTypeValidationJsContract[] | undefined;
    passwordConfiguration?: PasswordConfigurationJsContract | undefined;
    userImportPinLength?: number | undefined;
    isMpiEnabled?: boolean;
}

export interface ContactConfigurationJsContract {
    contactRequirement?: ContactsRequirement;
    maxNumberOfContacts?: number;
    contactType?: ContactTypeJsEnum;
}

export enum ContactsRequirement {
    None = 0,
    OneRequired = 1,
    OneVerified = 2,
    AllVerified = 3,
    OneRequiredAllVerified = 4,
}

export interface UserDataTypeValidationJsContract {
    name?: string | undefined;
    isRequired?: boolean;
    isInputHidden?: boolean;
    requiredByRoles?: string[] | undefined;
    valueValidation?: UserDataValueValidationJsContract | undefined;
}

export interface UserDataValueValidationJsContract {
    regex?: string | undefined;
    min?: string | undefined;
    max?: string | undefined;
}

export interface PasswordConfigurationJsContract {
    requireDigit?: boolean;
    requireLowercase?: boolean;
    requireUppercase?: boolean;
    requireNonAlphanumeric?: boolean;
    requiredLength?: number;
    requiredUniqueChars?: number;
}

export interface HtmlString {
    value?: string | undefined;
}

export interface LocalizationDictionaryJsContract {
    culture: string;
    scope: string;
    dictionary: { [key: string]: string; };
}

export interface CultureInfoJsContract {
    languageCode: string;
    localizedName: string;
}

export interface RepresentedPersonJsContract {
    firstName?: string[] | undefined;
    lastName?: string[] | undefined;
    birthdate?: string | undefined;
    insuranceCompanyCode?: string | undefined;
    insuranceNumber?: string | undefined;
    personalIdentificationNumber?: string | undefined;
    isRepresentedPersonLimitedToAdultAge?: boolean;
}

export interface RepresentedPersonDetailJsContract extends RepresentedPersonJsContract {
    activeTo?: string | undefined;
    userId?: number | undefined;
    masterUserId?: string | undefined;
    externalMpiId?: string | undefined;
}

export interface PagedListJsContractOfRepresentedPersonDetailJsContract {
    totalCount?: number;
    items?: RepresentedPersonDetailJsContract[] | undefined;
}

export interface RepresentedPersonFilterJsContract {
    firstName?: string | undefined;
    lastName?: string | undefined;
    birthdate?: string | undefined;
    insuranceNumber?: string | undefined;
}

export interface CreateRepresentedPersonJsContract extends RepresentedPersonJsContract {
    activeTo?: string | undefined;
    parentUserId?: number;
}

export interface VerificationActionViewModel {
    value?: VerificationUserDataAction;
    localizedLabel?: string | undefined;
    icon?: string | undefined;
    isDefault?: boolean;
}

export enum VerificationUserDataAction {
    Ignore = 0,
    Save = 1,
    SaveAndVerify = 2,
}

export interface PagedListJsContractOfUserAgreementJsContract {
    totalCount?: number;
    items?: UserAgreementJsContract[] | undefined;
}

export interface UserAgreementJsContract {
    id?: number;
    version?: string | undefined;
    agreedOn?: string | undefined;
    withdrawnOn?: string | undefined;
    agreed?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    personalNumber?: string | undefined;
}

export interface UserAgreementFilterJsContract {
    version?: string | undefined;
    agreedFromRangeStart?: string | undefined;
    agreedFromRangeEnd?: string | undefined;
    agreedToRangeStart?: string | undefined;
    agreedToRangeEnd?: string | undefined;
    agreed?: boolean | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    personalNumber?: string | undefined;
}

export interface LicenseTermsInfoViewModel {
    id?: number;
    name?: string | undefined;
    type?: LicenseTermsTypeEnumModel;
    activeOrLatestVersion?: LicenseTermsVersionWithLocalizedTextsViewModel | undefined;
}

export interface EditableLicenseTermsInfoViewModel extends LicenseTermsInfoViewModel {
    allTypes?: LicenseTermsTypeEnumModel[] | undefined;
}

export enum LicenseTermsTypeEnumModel {
    Mandatory = 0,
    Optional = 1,
    Informational = 2,
}

export interface LicenseTermsVersionInfoViewModel {
    id?: number;
    version: string;
    activeFrom?: string | undefined;
    activeTo?: string | undefined;
    licenseTerms?: LicenseTermsInfoViewModel | undefined;
}

export interface LicenseTermsVersionWithLocalizedTextsViewModel extends LicenseTermsVersionInfoViewModel {
    cultureList?: CultureModel[] | undefined;
    localizedNames?: CultureTextPairModel[] | undefined;
    localizedTexts?: CultureTextPairModel[] | undefined;
}

export interface CultureModel {
    name?: string | undefined;
    label?: string | undefined;
    isSelected?: boolean;
}

export interface CultureTextPairModel {
    culture?: string | undefined;
    text?: string | undefined;
}

export interface CreatePreregisteredPersonResponseJsContract {
    redirectUrl?: string | undefined;
    createdUserId?: number;
}

export interface PreregisteredUserJsContract {
    firstName?: string | undefined;
    lastName?: string | undefined;
    birthdate?: string;
    insuranceCompanyCode?: string | undefined;
    insuranceNumber?: string | undefined;
    personalIdentificationNumber?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
}

export interface LoginLockoutStateContract {
    lockoutEnabled?: boolean;
    lockoutEndDateUtc?: string | undefined;
    isLockedOut?: boolean;
}

export interface UserSignedInModel {
    isUserSignedIn?: boolean;
    signedOutRedirectUrl?: string | undefined;
}

export interface FrontendAppsettingsModel {
    itemsOnPage: ItemsOnPageConfig;
    isUserNoteEnabled: boolean;
    dateFormats: IValueFormatProvider;
    currentCulture: string;
    iconPaths: FrontendIconsModel;
}

export interface ItemsOnPageConfig {
    defaultValue?: number;
    options?: number[] | undefined;
}

export interface IValueFormatProvider {
    formatProvider?: IFormatProvider | undefined;
    date?: string | undefined;
    time?: string | undefined;
    dateTime?: string | undefined;
    dateTimeWithSeconds?: string | undefined;
    decimalSeparator?: string | undefined;
    thousandsSeparator?: string | undefined;
    flatpickrDateTimeWithSeconds?: string | undefined;
    flatpickrDateTime?: string | undefined;
    flatpickrDate?: string | undefined;
    amchartsDateTime?: string | undefined;
    amchartsDate?: string | undefined;
    momentDate?: string | undefined;
    momentDateTime?: string | undefined;
    momentDateTimeWithoutYear?: string | undefined;
    momentDateTimeWithoutSeconds?: string | undefined;
    momentJsServerDate?: string | undefined;
    amchartsDateTimeWithoutYear?: string | undefined;
    amchartsDateWithoutYear?: string | undefined;
}

export interface IFormatProvider {
}

export interface FrontendIconsModel {
    cardiogram?: string | undefined;
    meal?: string | undefined;
    sunrise?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}